import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_written_recs_of_complaints_and_grievances_and_the_mgmts_res'

export const dataPointDefinition = {
  retracedId: 'are_written_recs_of_complaints_and_grievances_and_the_mgmts_res',
  name: "Are written records of complaints and grievances and the management's response maintained for at least 12 months?",
  description: '',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'records',
    },
    {
      name: 'Yes- but records are incomplete',
      key: 'YES_BUT_RECS_ARE_INCOMPLETE',
      slcpIndex: 2,
      slcpOptionName: 'records',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 3,
      slcpOptionName: 'records',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'YES_BUT_RECS_ARE_INCOMPLETE', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'gr-6',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 13170,
  sectionId: '2.2.10',
  impactArea: 'Social Dialogue, Grievance Mechanisms and Disputes',
  impactAreaId: 'COMPLAINT_AND_GRIEVANCE_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
